export default __webpack_public_path__ + "static/media/new-5.0171aac4.png";